import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../store/userSlice";
import { reset } from "../../actions/users";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../routes";
import { useEffect } from "react";

const ChangePassword = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const password = useSelector((state) => state.user.recovery.password);
  const passwordConfirmation = useSelector(
    (state) => state.user.recovery.passwordConfirmation
  );
  const redirectTo = useSelector((state) => state.user.redirectTo);

  const onChangePassword = (event) => {
    dispatch(userActions.setRecoveryPassword(event.target.value));
  };
  const onChangeConfirmPassword = (event) => {
    dispatch(userActions.setRecoveryPasswordConfirmation(event.target.value));
  };
  const changePasswordHandler = () => {
    dispatch(reset(props.recovery_token, password, passwordConfirmation));
  };
  /*
  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo);
    }
  }, [redirectTo]);
  */
  return (
    <div>
      <Form>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInputEmail">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control
            type="password"
            onChange={onChangePassword}
            defaultValue={password}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="exampleForm.ControlInputName">
          <Form.Label>Confirmar Contraseña</Form.Label>
          <Form.Control
            type="password"
            onChange={onChangeConfirmPassword}
            defaultValue={passwordConfirmation}
          />
        </Form.Group>
      </Form>

      <Button
        disabled={password !== passwordConfirmation}
        onClick={changePasswordHandler}
      >
        Cambiar
      </Button>
    </div>
  );
};

export default ChangePassword;
